import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import LogsList from "components/menu/master-files/logs/list";
import LogsItem from "components/menu/master-files/logs/item";

import PrivateRoute from "components/common/PrivateRoute";

const LogsRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={LogsList}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/:name`}
                component={LogsItem}
            />
        </Switch>
    </div>
);

export default connect()(LogsRouter);
